var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "right-icon"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2589 11.279C14.018 10.1915 14.4766 8.82232 14.4766 7.33416C14.4766 3.7334 11.8009 0.81427 8.5 0.81427C5.19931 0.81427 2.52344 3.73322 2.52344 7.33416C2.52344 8.82189 2.98184 10.1912 3.74113 11.279C1.66109 11.548 0 13.4792 0 15.8825V16.9148C0 18.2629 1.00539 19.3597 2.24121 19.3597H14.7588C15.9946 19.3597 17 18.2629 17 16.9148V15.8825C17 13.4783 15.3381 11.5479 13.2589 11.279ZM8.5 2.55291C10.9206 2.55291 12.8828 4.69353 12.8828 7.33416C12.8828 9.97478 10.9206 12.1154 8.5 12.1154C6.07943 12.1154 4.11719 9.97478 4.11719 7.33416C4.11719 4.69353 6.07943 2.55291 8.5 2.55291ZM14.7588 17.6211C15.1164 17.6211 15.4062 17.3049 15.4062 16.9148V15.8825C15.4062 14.2821 14.217 12.9847 12.75 12.9847H11.4836C9.63442 14.147 7.35868 14.1427 5.51637 12.9847H4.25C2.78299 12.9847 1.59375 14.2821 1.59375 15.8825V16.9148C1.59375 17.3049 1.88361 17.6211 2.24121 17.6211H14.7588Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2589 11.279C14.018 10.1915 14.4766 8.82232 14.4766 7.33416C14.4766 3.7334 11.8009 0.81427 8.5 0.81427C5.19931 0.81427 2.52344 3.73322 2.52344 7.33416C2.52344 8.82189 2.98184 10.1912 3.74113 11.279C1.66109 11.548 0 13.4792 0 15.8825V16.9148C0 18.2629 1.00539 19.3597 2.24121 19.3597H14.7588C15.9946 19.3597 17 18.2629 17 16.9148V15.8825C17 13.4783 15.3381 11.5479 13.2589 11.279ZM8.5 2.55291C10.9206 2.55291 12.8828 4.69353 12.8828 7.33416C12.8828 9.97478 10.9206 12.1154 8.5 12.1154C6.07943 12.1154 4.11719 9.97478 4.11719 7.33416C4.11719 4.69353 6.07943 2.55291 8.5 2.55291ZM14.7588 17.6211C15.1164 17.6211 15.4062 17.3049 15.4062 16.9148V15.8825C15.4062 14.2821 14.217 12.9847 12.75 12.9847H11.4836C9.63442 14.147 7.35868 14.1427 5.51637 12.9847H4.25C2.78299 12.9847 1.59375 14.2821 1.59375 15.8825V16.9148C1.59375 17.3049 1.88361 17.6211 2.24121 17.6211H14.7588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_724)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.fb054791ccda6e84fcfca64587410ce0.svg";
export { ForwardRef as ReactComponent };